<template>
  <el-col
    class="card-col"
  >
    <slot></slot>
  </el-col>
</template>

<script>
export default {

};
</script>

<style lang="scss">
.card-col {
  max-width: 100%;
  margin-bottom: 16px;
  width: 100%;

  @include breakpoint-up(xs) { width: 50%; }
  @include breakpoint-up(sm) { width: 275px; }
  @include breakpoint-up(md) { width: 330px; }
}

.item {
  position: relative;
  height: 250px;
}

.item--empty {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Shared/CardCol.vue